import api from "../../../api";
import { createErrorMessage, createSuccessMessage } from "../../../service";

const ConsumptionAccounting = {
  resource: "accounting",
  preList: function(params) {
    return `projects/${params.project_id}`;
  },
  getList(type, params = {}, onSuccess = () => {}, onError = () => {}) {
    params.filters = api.helpers.formFilters(params.filters);
    Object.keys(params).forEach(key => !params[key] && delete params[key]);
    return api
      .get(`/${this.preList(params)}/${this.resource}/${type}`, {
        params
      })
      .then(res => {
        let data = { list: res.data.items };
        onSuccess(data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  getConsumptionList(params = {}, onSuccess = () => {}, onError = () => {}) {
    return this.getList("consumption", params, onSuccess, onError);
  },
  getProportionsList(params = {}, onSuccess = () => {}, onError = () => {}) {
    return this.getList("proportions", params, onSuccess, onError);
  },
  getCountsList(params = {}, onSuccess = () => {}, onError = () => {}) {
    return this.getList("counts", params, onSuccess, onError);
  },
  create(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    let preList = this.preList(params);
    return api
      .post(
        `${preList ? "/" + preList : ""}/${this.resource}/documents`,
        params
      )
      .then(res => {
        createSuccessMessage("create-document");
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  }
};
export default ConsumptionAccounting;
